import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { FiltersTypes } from "../../../common/types/filters/general";
import { useWorkspaceContext } from "../../../state/workspaceContext";
import { getBackendAPIClient } from "../../../lib/backendAPIClient";
import { categoryContract } from "../../../common/contracts/category.contract";

const categoryContractClient = getBackendAPIClient(categoryContract);

export function useCategoryStatistics(
    filters: Pick<FiltersTypes, "entityIds" | "start" | "end">,
) {
    const { activeWorkspace } = useWorkspaceContext();

    if (!activeWorkspace) {
        throw new Error("No active workspace");
    }

    return useQuery({
        queryKey: ["categoryStatistics", filters],
        queryFn: () =>
            categoryContractClient.getCategoryStatistics({
                query: {
                    entityIds: filters.entityIds,
                    start: filters.start,
                    end: filters.end,
                },
                params: { workspaceId: activeWorkspace.id },
            }),
        placeholderData: keepPreviousData,
    });
}
